import React, { useEffect } from 'react';
import { sendNewUserImpressionEvents } from '../../../../helpers/analytics/newUser.analytics';
import { EmptyState } from '../../../commons';
import { AgentActions, HelpButton, User, UserV1 } from '../../../widgets';
import './NewUser.scss';

export const NewUser = ({
  details = null,
  isWFH = false,
  handleHelpOpen = () => {},
}) => {
  useEffect(() => {
    sendNewUserImpressionEvents(details?.user_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details]);

  return (
    <div className='new_user col'>
      <div className='card user_detail'>
        <UserV1
          hasAnyOrders={false}
          orderId={null}
          userId={details?.user_id}
          isWFH={isWFH}
          isNewUser={!!details?.user_id}
        />
        <div>
          <AgentActions
            orderId={''}
            userId={details?.user_id}
            isNewUser={!!details?.user_id}
          />
        </div>
      </div>
      <div className='card row'>
        <EmptyState
          imageWidth='25rem'
          img={details?.image_url}
          heading={details?.heading?.text || 'User has not ordered ever'}
          subHeading={details?.sub_heading?.text}
        />
      </div>
    </div>
  );
};
